import React from 'react';

const OmbInfo = () => {
  return (
    <div className="vads-u-margin-bottom--1p5">
      <p className="vads-u-margin--0">
        <span>Respondent burden:</span>{' '}
        <span className="vads-u-font-weight--bold">15 minutes</span>
      </p>
      <p className="vads-u-margin--0">
        <span>OMB Control #:</span>{' '}
        <span className="vads-u-font-weight--bold">2900-0892</span>
      </p>
      <p className="vads-u-margin--0">
        <span>Expiration date:</span>{' '}
        <span className="vads-u-font-weight--bold">01/31/2028</span>
      </p>
    </div>
  );
};

export default OmbInfo;
